<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">
        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <div class="flex flex-col">
                    <LabelControl type="subtitle" :content="$t('smp001')" />
                </div>
            </SidebarSection>
            <ContentSection @logout="logout" :show_back="false">
                <div class="bg-white">
                        <div class="m-10">
                            <CardControl @click="this.retrieveBalances()" :rectangle="true" :width="56" :height="10"
                            :icon_height="50" :icon_width="50" :margin="30" :title="$t('smp002')" icon_id="passbook" />
                        </div>
                        <div class="m-10">
                            <CardControl @click="handleRedirect('/services/view-member-info')" :rectangle="true" :width="56" :height="10"
                        :icon_height="50" :icon_width="50" :margin="30"
                            :title="$t('smp003')" icon_id="account" />
                        </div>
                        <div class="m-10">
                            <CardControl @click="handleRedirect('/help')" :title="$t('smp005')" :rectangle="true" :width="56" :height="10"
                            :icon_height="50" :icon_width="50" :margin="30"
                                icon_id="help"  />
                        </div>
                    
                </div>

                <!-- Existing Session -->
                <transition name="slide-in">
                    <ModalControl :is_visible="this.existing_session">
                        <SessionTimeoutControl />
                    </ModalControl>
                </transition>

            </ContentSection>
        </div>
        <FooterSection />
    </div>
</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';
import CardControl from '@/components/controls/CardControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import SessionTimeoutControl from '@/components/controls/SessionTimeoutControl.vue';
import user from '@/services/user';

export default {
    mixins: [mixin],
    inject: ['setLoading', 'setError'],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
        CardControl,
        ModalControl,
        SessionTimeoutControl
    },
    mounted() {
        this.$emit('checkauth');
        if (this.$route.query.existing_session) {
            this.toggleExistingSessionModal();
            this.resetUserData();
            this.clearUserCookie();
        }
        
    },
    data() {
        return {
            hash: this.$store.state.user.hash,
            uuid: this.$store.state.user.uuid,
            balance_ref: this.$store.state.user.balance_ref,
            existing_session: false,
            balance_delay: parseInt(process.env.VUE_APP_BALANCE_FETCH_DELAY, 10),
        }
    },
    methods: {
        logout() {
            this.$emit('logout');
        },
        retrieveBalances() {
            const ledgers = this.$store.state.user.ledgers;
            if (ledgers.length > 0) {
                this.$router.push({ name: 'balance-inquiry-page' });
                return;
            }
            this.setLoading(true);
            user.fetchBalances(this.hash, this.uuid, this.balance_ref).then((response) => {
                const balances = response.data.data;
                Object.entries(balances).forEach(([code, {total_balance, total_records, as_of}]) => {
                    this.$store.commit('addBalance', { code: code, balance: total_balance, records: total_records, as_of: as_of  });
                });
                this.$router.push({ name: 'balance-inquiry-page' });
                this.setLoading(false);
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.setLoading(false);
                    this.$router.push({ name: 'services-page', query: { existing_session: true } });
                }
                // else if (error.response && error.response.status === 417) {
                //     let timer = setTimeout(() => {
                //         this.retrieveBalances();
                //         clearTimeout(timer);
                //     }, this.balance_delay);
                // }
                this.showError(error.response.data.message);
                this.setLoading(false);
                this.$router.push({ name: "login-page" }); 
            });
        },
    },
};
</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-text {
    height: 36rem;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* Two columns */
    gap: 3rem;
    /* Tailwind's gap-4 equivalent */
}


@media (min-width: 2500px) {
  .card-container {
    height: 15rem !important;
    width:  75rem !important;
  }

  .bg-white {
    margin-top: 10rem !important;
  }

  .papsi-icon {
    width: 60px !important;
    height: 60px !important;
  }
}
</style>
